export function formatEur(n) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
}
export function today() {
  return new Date().toISOString().split("T")[0];
}
export function daysUntil(d) {
  if (!d) return 999;
  return Math.ceil((new Date(d) - new Date(today())) / (1000 * 60 * 60 * 24));
}
